const mainAreaPadding = '20px';

export { mainAreaPadding };